import {
  cubeOutline,
  listOutline,
  peopleOutline,
  receiptOutline,
  settingsOutline,
} from 'ionicons/icons';

/** One admin destination: `key` is the `menu.<key>` label, `tone` its colour. */
export interface AdminPage {
  key: string;
  url: string;
  icon: string;
  tone: string;
}

/**
 * Every admin page, in menu order — the single list behind both the drawer's
 * expandable Admin group (`AppComponent`) and the floating Admin button
 * (`AdminFabComponent`). Each route is guarded by `requireLoginGuard`, which
 * needs an admin token; the API re-checks the role on every request.
 */
export const ADMIN_PAGES: readonly AdminPage[] = [
  { key: 'inventory', url: '/admin', icon: cubeOutline, tone: '#f59e0b' },
  {
    key: 'adminUsers',
    url: '/admin/users',
    icon: peopleOutline,
    tone: '#8b5cf6',
  },
  {
    key: 'adminOrders',
    url: '/admin/orders',
    icon: receiptOutline,
    tone: '#0ea5e9',
  },
  {
    key: 'adminRequests',
    url: '/admin/requests',
    icon: listOutline,
    tone: '#ec4899',
  },
  {
    key: 'adminSettings',
    url: '/admin/settings',
    icon: settingsOutline,
    tone: '#64748b',
  },
];
